export const predictionChartConfig = {
  backgroundColor: '#E0E0E0',
  lineWidth: 4.5,
  tooltipMessages: {
    default: 'Difference between today’s and yesterday’s failure probabilities',
    critical: 'Amount of days in alarm state',
  },
};
